import './main.css'
import '../App.css'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faGem, faGamepad } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { ChevronRight } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { changeUnits } from './common/function';
import { useTranslation } from "react-i18next";
import { checkDuplicateLogins } from '../store';

function Memories() {
    const { t } = useTranslation();
    let JWT = useSelector((state) => { return state.JWT.value })
    const [memoriesList, setMemoriesList] = useState([])
    let dispatch = useDispatch()

    useEffect(() => {
        MemoriesData()
    }, [])

    const MemoriesData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/jackpot', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setMemoriesList(tmp?.data?.jackpot ?? [])
            }
        }).catch((error) => {
             if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    return (
        <div className='main notheader'>
            <div className='memories'>
                <div className='settings-header'>{t('memories_0')}</div>
                <div className='settings-subheader'>{t('memories_1')}</div>
                <div className=''>
                    {
                        memoriesList.map(function (a, i) {
                            return (
                                <>
                                    <MemoriesItem key={i} item={a} />
                                </>
                            )
                        })
                    }
                </div>
            </div>
        </div>

    )
}

function MemoriesItem({ item }) {
    return (
        <div className={`memories-list`}>
            {
                item.awarded_amount >= 600
                    ?
                    item.awarded_amount >= 1000
                        ?
                        <img src='/newImg/icon_goldenbox_big.png' style={{ width: "38px" }} />
                        :
                        <img src='/newImg/icon_goldenbox_medium.png' style={{ width: "38px" }} />
                    :
                    <img src='/newImg/icon_goldenbox_small.png' style={{ width: "38px" }} />
            }
            <div className='memories-list-text' style={{ width: "100%" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: "100%" }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "20px" }} />
                        <div style={{ paddingLeft: "5px" }}>
                            <div className="fontNumber" style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeUnits(item.awarded_amount ?? 0)}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ fontSize: "12px" }}>{item.updated_at}</div>
                </div>
            </div>
        </div>
    )
}

export default Memories;